const ACCOUNT_HOLDER_NAME_PATTERN = /^([\p{L}]+(([,. ] |[ '-])[\p{L}]+)*(\.?)?) ([\p{L}]+(([,. ] |[ '-])[\p{L}]+)*(\.?)?)$/u;

const BANK_NAME_FREE_TEXT_PATTERN = /^[\p{L}\p{N}\s,.'-]+$/u;

function isValidAccountHolderName(value: string): boolean {
  return ACCOUNT_HOLDER_NAME_PATTERN.test(value.trim());
}

function isValidBankDisplayName(value: string): boolean {
  const trimmed = value.trim();
  if (trimmed.length === 0) return false;
  return BANK_NAME_FREE_TEXT_PATTERN.test(trimmed);
}

export { isValidAccountHolderName, isValidBankDisplayName };
